import { render, staticRenderFns } from "./ReflectionDialog.vue?vue&type=template&id=261bc6bc&scoped=true&"
import script from "./ReflectionDialog.vue?vue&type=script&lang=js&"
export * from "./ReflectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReflectionDialog.vue?vue&type=style&index=0&id=261bc6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261bc6bc",
  null
  
)

export default component.exports